<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>

    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Create A New Skid/ Group</p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <v-form :valid.sync="valid" class="modal-card-body">

          <div class="field">
            <label class="label">Project</label>
            <search-autocomplete
              required 
              v-model="skid.project_id"/>
          </div>

          <div class="field">
            <label class="label">Skid Number</label>
            <v-text-field
              required
              placeholder="Input Skid Number" 
              v-model="skid.skid_no"/>
          </div>

          <div class="field">
            <label class="label">Description</label>
            <v-text-field
              placeholder="Skid Description" 
              v-model="skid.desc"/>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            class="button is-primary"
            :class="{ 'is-loading': saving }"
            :disabled="!valid || !skid.project_id || !skid.skid_no || saving" 
            @click="createSkid()">
            Save
          </button>
          <button 
            class="button is-primary" 
            :class="{ 'is-loading': saving }"
            :disabled="!valid || !skid.project_id || !skid.skid_no || saving" 
            @click="createSkid(true)">
            Save and Add Skid Details
          </button>
          <button class="button" @click="close()">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VTextField from '@/components/base/VTextField'
import SearchAutocomplete from '@/components/projects/SearchAutocomplete'
import VForm from '@/components/base/VForm'
import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { SearchAutocomplete, VTextField, VForm },
  data() {
    return {
      valid: false,
      skid: {
        project_id: null,
        skid_no: null,
        desc: null
      },
      saving: false
    }
  },
  methods: {
    ...mapActions("skidInstallations", ["addSkid"]),
    createSkid(next=false) {
      this.saving = true;
      this.addSkid(this.skid).then(resp => {
        this.saving = false;
        if (next) {
          this.$router.push({ 
            name: 'SkidViewer', 
            params: { 
              skidId: resp.data.id,
              skid: resp.data
            }
          })
        }
        this.close();
      }).catch(() => {
        this.saving = false;
      })
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>